export default "__VITE_ASSET__ChmCXX5p__"